import EventEmitter from 'eventemitter3';
import { debug } from '../utils/logger';
export default class TypedEmitter {
    emitter = new EventEmitter();
    on(eventName, fn) {
        this.emitter.on(eventName, fn);
        return this;
    }
    once(eventName, fn) {
        this.emitter.once(eventName, fn);
        return this;
    }
    off(eventName, fn) {
        this.emitter.off(eventName, fn);
        return this;
    }
    emit(eventName, params) {
        debug(`> [${this.constructor.name}]: ${eventName}`, params);
        this.emitter.emit(eventName, { eventType: eventName, ...params });
        return this;
    }
}
